export default {
  loading: false,
  message: {
    type: null,
    content: null,
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js